<div class="mat-body-1">
	{{gitInfo.commit}} - {{gitInfo.branch}} - Committed on {{gitInfo.date | date: 'long'}}
</div>
